import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const NftPage = () => {
  // Extract folder and tokenId from the URL using useParams
  const { folder, tokenId } = useParams();
  
  // States to handle image URL, loading, and error
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Construct the image URL based on folder and tokenId
  useEffect(() => {
    const constructedImageUrl = `/nft/images/${folder ? `${folder}/` : ''}${tokenId}`;

    // Set the image URL state
    setImageUrl(constructedImageUrl);

    // You could add any image validation or additional loading logic here if needed
    setLoading(false);
  }, [folder, tokenId]);  // Re-run if folder or tokenId changes

  // Error handling for missing images (optional)
  const handleError = () => {
    setError('Image not found.');
  };

  if (loading) {
    return <div>Loading NFT data...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <h1>NFT Page</h1>
      <div>
        {/* Render the image */}
        <img 
          src={imageUrl} 
          alt={`NFT ${tokenId}`} 
          onError={handleError}  // Handle error if the image fails to load
        />
        <p>Image Token ID: {tokenId}</p>
        {folder && <p>Folder: {folder}</p>}
      </div>
    </div>
  );
};

export default NftPage;
